import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router';

const DEFAULT_THEME_COLOR = '#ffffff';

export const backgroundColorToThemeColor = (backgroundColor: string): string => {
  const normalized = backgroundColor.replaceAll(/\s/g, '');
  if (!backgroundColor || backgroundColor === 'transparent' || normalized === 'rgba(0,0,0,0)') {
    return DEFAULT_THEME_COLOR;
  }
  return backgroundColor;
};

const readThemeColorFromDocument = () =>
  backgroundColorToThemeColor(getComputedStyle(document.documentElement).backgroundColor);

const useDocumentThemeColor = () => {
  const { pathname } = useLocation();
  const [themeColor, setThemeColor] = useState(readThemeColorFromDocument);

  useLayoutEffect(() => {
    const sync = () => setThemeColor(readThemeColorFromDocument());
    sync();

    const observer = new MutationObserver(sync);
    const root = document.getElementById('root');
    if (root) {
      observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-layout-bg'],
      });
    }

    return () => observer.disconnect();
  }, [pathname]);

  return themeColor;
};

export default useDocumentThemeColor;
